import { AfterViewInit, ChangeDetectorRef, Component, DoCheck, OnInit, ViewChild } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { PedidoDetalle } from '../PedidoDetalle';
import { PedidoEntidad } from '../PedidoEntidad';
import { PedidosService } from '../pedidos.service';

@Component({
  selector: 'app-verpedido',
  templateUrl: './verpedido.component.html',
  styleUrls: ['./verpedido.component.css']
})
export class VerpedidoComponent implements OnInit, AfterViewInit,DoCheck {
  id: number;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  pedido: PedidoEntidad;
  cliente: PedidoEntidad= new PedidoEntidad();
  compraDetalle: PedidoDetalle[] = [];
  listaCompras: PedidoDetalle[] = [];
  urlSafe: SafeResourceUrl;
  constructor(private api:PedidosService, private cdRef: ChangeDetectorRef,private alertService: AlertService,private route: ActivatedRoute, private ruter: Router) { }
  ngDoCheck(): void {

  }

  ngOnInit(): void {
    this.id = Number(this.route.snapshot.paramMap.get('id'));
    console.log(this.id);
    this.listaDetallePedido();
  }

listaDetallePedido(){
        this.api.buscarPedidoDetalle(this.id)
          .subscribe((
            data1: PedidoDetalle[]) => {
            this.compraDetalle = data1;   
            this.mdbTable.setDataSource(  this.compraDetalle );
             

          },
            err => this.alertService.danger('Error no hay  conexion..')
          );
        }
  




ngAfterViewInit() {
  this.cdRef.detectChanges();
}



  regresar() {
    this.ruter.navigate(['pedido']);
  }



}
